import * as dayjs from 'dayjs';
import { hasResourceType, ShowBrandingInterface, ShowInterface, SplixerResourceTypes } from '@splixer/common';
import { AnyHash, nString } from '@hidat/huijs-common';
import { PlayerExtendedBranding } from './extended-branding.model';
import { Expose, Transform, Type } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';

export class PlayerShowBranding
  extends PlayerExtendedBranding
  implements ShowBrandingInterface
{
  @Expose({ name: 'credits' })
  credits?: nString = undefined;
  @Expose({ name: 'performers' })
  performers?: nString = undefined;
  @Expose({ name: 'urls' })
  urls?: AnyHash | undefined = undefined;
}

export class PlayerShowBase implements ShowInterface, hasResourceType {
  resourceType = SplixerResourceTypes.Show;

  id = -1;
  @Expose({ toClassOnly: true })
  uid: number | undefined = undefined;
  @Expose({ name: 'status' })
  status = 100;
  @Expose({ name: 'created_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  createdAt: dayjs.Dayjs | undefined = undefined;
  @Expose({ name: 'updated_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  updatedAt: dayjs.Dayjs | undefined = undefined;

  //@ToDo The rest....
  @Expose({ name: 'name' })
  name: string | undefined = undefined;
  @Expose({ name: 'tag_line' })
  tagLine: string | undefined = undefined;
  @Expose({ name: 'description' })
  description: string | undefined = undefined;
  @Expose({ name: 'image_url' })
  imageUrl: string | undefined = undefined;
  @Expose({ name: 'extended' })
  @Type(() => PlayerShowBranding)
  branding: PlayerShowBranding = {};
  @Expose({ name: 'host_name' })
  hostName: string | undefined = undefined;

  @Expose({ name: 'started_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  startedAt: dayjs.Dayjs | undefined = undefined;
  @Expose({ name: 'ended_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  endedAt: dayjs.Dayjs | undefined = undefined;
  @Expose({ name: 'duration' })
  duration = 0;
  @Expose({ name: 'valid_segments' })
  validSegments: number | undefined = undefined;
  @Expose({ name: 'invalid_segments' })
  invalidSegments: number | undefined = undefined;

  @Expose({ name: 'channel_id' })
  channelId: number | undefined = undefined;
  @Expose({ name: 'host_id' })
  hostId: number | undefined = undefined;
  @Expose({ name: 'program_id' })
  programId: number | undefined = undefined;
  @Expose({ name: 'station_id' })
  stationId: number | undefined = undefined;
  @Expose({ name: 'remote_id' })
  remoteId: number | undefined = undefined;
  @Expose({ name: 'raw_show_id' })
  rawShowId: number | undefined = undefined;
  @Expose({ name: 'dow' })
  dow: number | undefined = undefined;
  @Expose({ name: 'timeOfDay' })
  timeOfDay: number | undefined = undefined;
  @Expose({ name: 'priority' })
  priority: number | undefined = undefined;
}
